import isFile from './isFile'

const isImage = url => isFile(url, ['png', 'jpg', 'jpeg', 'svg', 'gif', 'webp'])
export default isImage
